module.exports = __webpack_public_path__ + "static/media/background-kakao-panda-m.0b83f14a.png";